import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';
// const API_URL = 'http://192.168.100.71:8000'; // para que funcione desde todos los equipos

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Mensajes de error en español por código HTTP
const errorMessages: Record<number, string> = {
  400: 'Solicitud incorrecta. Verifica los datos ingresados.',
  403: 'No tienes permiso para realizar esta accion.',
  404: 'El recurso solicitado no fue encontrado.',
  409: 'Conflicto: el recurso ya existe o no se puede modificar.',
  422: 'Datos invalidos. Revisa los campos del formulario.',
  500: 'Error interno del servidor. Intenta nuevamente.',
  502: 'El servidor no esta disponible. Intenta mas tarde.',
  503: 'Servicio no disponible. Intenta mas tarde.',
};

// Interceptor para manejar errores de autenticación y traducir mensajes
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    if (error.response?.status && errorMessages[error.response.status]) {
      error.userMessage = errorMessages[error.response.status];
    } else if (!error.response) {
      error.userMessage = 'No se pudo conectar al servidor. Verifica tu conexion.';
    }

    return Promise.reject(error);
  }
);

// Configurar token si existe
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
